import React from 'react'

import { Button, Text, Tooltip } from 'components/ds'

/** Cancel subscription for Enterprise plans, unavailable because their account manager handles cancellations. */
const EnterpriseCancelButton = (): React.ReactNode => (
  <Tooltip content="As part of your enterprise plan, cancellations are handled directly by your account manager. To proceed, please get in touch with them and they’ll guide you through the process.">
    {/* aria-disabled instead of disabled: a natively disabled button swallows the pointer events its tooltip needs */}
    <Button variant="ghost" color="red" size="2" aria-disabled data-disabled>
      <Text size="2">Cancel subscription</Text>
    </Button>
  </Tooltip>
)

export default EnterpriseCancelButton
